import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Scale, Landmark, HeartHandshake, Users, GraduationCap, Activity, TrendingUp, Sparkles } from 'lucide-react';
const areas = [{
  icon: Scale,
  title: 'Healthcare Advocacy',
  body: 'Championing the physician-patient relationship through principled, bipartisan advocacy at the state and federal levels.',
  metric: '45+ legislative wins'
}, {
  icon: Landmark,
  title: 'Legislative Success',
  body: 'Leading policy strategy and coalition building to advance healthcare priorities through complex legislative environments.',
  metric: 'Multiple statewide initiatives'
}, {
  icon: HeartHandshake,
  title: 'Strategic Partnerships',
  body: 'Forging durable partnerships across providers, payers, and policymakers to strengthen healthcare systems.',
  metric: '30+ partner organizations'
}, {
  icon: Users,
  title: 'Physician Workforce Development',
  body: 'Designing programs that recruit, retain, and support the physician workforce across the state.',
  metric: 'Workforce pipeline programs'
}, {
  icon: GraduationCap,
  title: 'Medical Education Support',
  body: 'Expanding scholarships and foundation funding to invest in the next generation of healthcare leaders.',
  metric: 'New scholarship programs'
}, {
  icon: Activity,
  title: 'Healthcare Reform Initiatives',
  body: 'Advising on reform efforts that improve access, quality, and sustainability of care.',
  metric: "Governor's task force"
}, {
  icon: TrendingUp,
  title: 'Organizational Growth Strategies',
  body: 'Driving membership, revenue, and impact through disciplined strategy and operational excellence.',
  metric: '312% revenue growth'
}, {
  icon: Sparkles,
  title: 'Healthcare Transformation Projects',
  body: 'Leading transformation initiatives that modernize operations and improve outcomes.',
  metric: 'Multiple transformation projects'
}];
export function Leadership() {
  useEffect(() => {
    document.title = 'Healthcare Leadership & Impact | Michelle McOmber';
  }, []);
  return <div className="w-full bg-white" data-id="element-371">
      <header className="bg-navy-900 text-white py-20" data-id="element-372">
        <div className="max-w-7xl mx-auto px-6" data-id="element-373">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-374">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-375">
              Healthcare Leadership &amp; Impact
            </h1>
            <p className="text-xl text-slate-300 max-w-2xl" data-id="element-376">
              A portfolio of advocacy, transformation, and growth initiatives
              that have reshaped healthcare communities.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="py-24" data-id="element-377">
        <div className="max-w-7xl mx-auto px-6" data-id="element-378">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-379">
            {areas.map((a, i) => <motion.article key={a.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.05
          }} className="group border border-slate-100 rounded-xl p-8 hover:shadow-executive transition-shadow flex gap-6" data-id="element-380">
                <div className="w-14 h-14 shrink-0 bg-slate-50 rounded-lg flex items-center justify-center text-navy-900 group-hover:bg-navy-900 group-hover:text-white transition-colors" data-id="element-381">
                  <a.icon className="w-7 h-7" data-id="element-382" />
                </div>
                <div data-id="element-383">
                  <h2 className="text-xl font-bold text-navy-900 mb-2" data-id="element-384">
                    {a.title}
                  </h2>
                  <p className="text-slate-600 mb-4 leading-relaxed" data-id="element-385">
                    {a.body}
                  </p>
                  <span className="inline-block text-gold font-semibold text-sm" data-id="element-386">
                    {a.metric}
                  </span>
                </div>
              </motion.article>)}
          </div>
        </div>
      </section>
    </div>;
}